import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { ProgramSimulationExample } from '../../../model/program';
import { ProgramSimulationExampleActionTypes } from './types';

export const programSimulationExampleRequest = (programId: string) => action(ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_REQUEST, programId);
export const programSimulationExampleSuccess = (example: ProgramSimulationExample) => action(ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_SUCCESS, example);
export const programSimulationExampleError = (error: GiroWebappError) => action(ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_ERROR, error);
export const programSimulationExampleResetState = () => action(ProgramSimulationExampleActionTypes.PROGRAM_SIMULATION_EXAMPLE_RESET_STATE);
